import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  Output,
  EventEmitter,
  Input,
  ViewRef,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-door-dimension-slider',
  templateUrl: './door-dimension-slider.component.html',
  styleUrls: ['./door-dimension-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoorDimensionSliderComponent implements OnInit, OnDestroy, AfterViewInit {
  public unsubscribe: Subject<void> = new Subject();
  @Output() valueChanged = new EventEmitter<any>();
  private _range: number[] = [0];
  @ViewChild('slider') slider: ElementRef<HTMLInputElement>;

  _val: number;

  @Input() set value(val: number) {
    if (val === this._val) {
      return;
    }

    this._val = val;

    this.valueChanged.emit(this._val);
    this.sliderValue = this.value;
    if (!!this.slider && !!this.slider.nativeElement) {
      this.slider.nativeElement.value = '' + this.sliderValue;
    }
    this.error = false;
    this.changeDetector.detectChanges();
  }

  get value(): number {
    return this._val;
  }

  @Input() set range(value: number[]) {
    this._range = value;

    if (this._range === undefined) {
      return;
    }

    if (this._range.length > 1) {
      if (this._range[0] && this.min !== this._range[0]) {
        this.min = this._range[0];
      }
      const max = this._range[this._range.length - 1];
      if (max && this.max !== max) {
        this.max = max;
      }
    } else if (this._range.length === 1) {
      this.min = this._range[0] - 1;
      this.max = this._range[0] + 1;
    }

    this.sliderValue = this.value;
    if (!!this.slider && !!this.slider.nativeElement) {
      this.slider.nativeElement.value = '' + this.sliderValue;
    }
    this.changeDetector.detectChanges();
  }

  min: number;
  max: number;
  sliderValue = 900;
  error: boolean;

  constructor(
    private domSanitizer: DomSanitizer,
    private changeDetector: ChangeDetectorRef
  ) {}

  get style(): SafeStyle {
    const styleString = `--min: ${this.min};
                         --max: ${this.max};
                         --val: ${this.sliderValue}`;
    return this.domSanitizer.bypassSecurityTrustStyle(styleString);
  }

  get isEditingEnabled() {
    return this._range.length > 1;
  }

  ngOnInit() {
    this.sliderValue = this._val;
  }
  ngAfterViewInit() {
    if (!!this.slider && !!this.slider.nativeElement) {
      this.slider.nativeElement.value = '' + this.sliderValue;
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.unsubscribe();
  }

  setProgressSlider(event: any) {
    const closest = this._range.reduce((prev, curr) => {
      return Math.abs(curr - +event.target.value) < Math.abs(prev - +event.target.value) ? curr : prev;
    });

    this.sliderValue = event.target.valueAsNumber;
    this.value = closest;
    this.error = false;
    this.changeDetector.detectChanges();
  }

  sliderMouseUp() {
    setTimeout(() => {
      if (this.changeDetector && !(this.changeDetector as ViewRef).destroyed) {
        this.sliderValue = this.value;
        this.changeDetector.detectChanges();
      }
    }, 10);
  }

  inputChanged(target: HTMLInputElement) {
    if (!this._range.includes(+target.value)) {
      this.error = true;
    } else {
      this.value = +target.value;
      this.error = false;
    }

    this.changeDetector.detectChanges();
  }
}
